// Public legal pages for Managen: Privacy Policy (/privacy) and Terms of Service (/terms).
// Rendered into #root for any visitor (auth not required). Reuses the landing nav/footer.

const EFFECTIVE_DATE = 'July 22, 2026';
const COMPANY = 'Managen';
const CONTACT_EMAIL = 'things4u19@gmail.com';
const PRIVACY_EMAIL = 'things4u19@gmail.com';
const GOVERNING_STATE = 'California';

function navHtml() {
  return `
    <nav class="lp-nav">
      <a class="lp-logo" href="/" aria-label="Managen home">
        <span class="lp-logo-mark">M</span>
        <span class="lp-logo-name">MANA<span class="ll">GEN</span></span>
      </a>
      <div class="lp-nav-actions">
        <button class="btn ghost sm" data-cta="signin">Sign In</button>
        <button class="btn primary sm" data-cta="signup">Start Free</button>
      </div>
    </nav>`;
}

function footerHtml() {
  return `
    <footer class="lp-footer">
      <div class="lp-container lp-footer-inner">
        <span>© 2026 Managen</span>
        <span class="lp-dot">·</span>
        <a href="/privacy">Privacy Policy</a>
        <span class="lp-dot">·</span>
        <a href="/terms">Terms of Service</a>
      </div>
    </footer>`;
}

function privacyBody() {
  return `
    <h1>Privacy Policy</h1>
    <div class="legal-updated">Last updated: ${EFFECTIVE_DATE}</div>

    <p>${COMPANY} ("we," "us," or "our") operates an AI-powered content generation
    platform (the "Service"). This Privacy Policy explains what information we collect,
    how we use it, and the choices you have. ${COMPANY} is based in the United States.
    By using the Service, you agree to the practices described here.</p>

    <h2>1. Information We Collect</h2>
    <ul>
      <li><strong>Account information.</strong> When you create an account, we collect your
      email address and an encrypted password.</li>
      <li><strong>Content you provide.</strong> The briefs, prompts, client details, brand
      voice notes, and other inputs you enter, along with the content the Service generates
      for you.</li>
      <li><strong>Billing information.</strong> If you subscribe to a paid plan, payment is
      processed by our payment provider, Stripe. We do not store your full card number; we
      receive limited billing details such as your subscription status and a Stripe customer
      identifier.</li>
      <li><strong>Usage data.</strong> Basic activity such as generation counts, feature
      usage, and timestamps, used to enforce plan limits and improve the Service.</li>
      <li><strong>Local storage.</strong> We store limited preferences in your browser's
      local storage (for example, follow-up interval settings). We do not use third-party
      advertising cookies.</li>
    </ul>

    <h2>2. How We Use Your Information</h2>
    <ul>
      <li>To provide, operate, and maintain the Service.</li>
      <li>To generate content in response to your requests.</li>
      <li>To process subscriptions, billing, and plan limits.</li>
      <li>To authenticate you and secure your account.</li>
      <li>To respond to support requests and communicate service-related updates.</li>
      <li>To detect, prevent, and address abuse, fraud, or technical issues.</li>
    </ul>

    <h2>3. Third-Party Service Providers</h2>
    <p>We rely on the following subprocessors to operate the Service. Your information is
    shared with them only as needed to provide the Service:</p>
    <ul>
      <li><strong>Anthropic</strong> — powers AI content generation. The prompts and briefs
      you submit for generation are transmitted to Anthropic's API to produce output.</li>
      <li><strong>Supabase</strong> — provides database, authentication, and backend hosting.
      Your account data and saved content are stored here.</li>
      <li><strong>Stripe</strong> — processes subscription payments.</li>
      <li><strong>Vercel</strong> — hosts and serves the web application.</li>
    </ul>
    <p>Each provider processes data under its own privacy and security terms. We do not sell
    your personal information.</p>

    <h2>4. AI-Generated Content</h2>
    <p>Content you submit for generation is sent to Anthropic's API to return a result. You
    are responsible for reviewing generated output before use. Do not submit sensitive
    personal data, confidential information, or anything you are not authorized to share.</p>

    <h2>5. Data Storage and Security</h2>
    <p>Your data is stored in databases managed by Supabase and protected by access controls
    and row-level security. While we take reasonable measures to protect your information, no
    method of transmission or storage is completely secure, and we cannot guarantee absolute
    security.</p>

    <h2>6. Data Retention</h2>
    <p>We retain your account information and content for as long as your account is active.
    You can delete your generated content at any time within the app, and the "Wipe All Data"
    feature in your account settings removes your clients, library, invoices, contacts, and
    activity. Deleting your account removes your associated data, subject to any retention we
    are legally required to maintain.</p>

    <h2>7. Your Rights and Choices</h2>
    <p>Depending on your location, you may have the right to access, correct, export, or
    delete your personal information. You can manage much of your data directly in the app, or
    contact us at <a href="mailto:${PRIVACY_EMAIL}">${PRIVACY_EMAIL}</a> to make a request.</p>

    <h2>8. Children's Privacy</h2>
    <p>The Service is not directed to individuals under 18, and we do not knowingly collect
    personal information from children.</p>

    <h2>9. International Users</h2>
    <p>The Service is operated from the United States. If you access it from outside the U.S.,
    your information may be transferred to, stored, and processed in the United States.</p>

    <h2>10. Changes to This Policy</h2>
    <p>We may update this Privacy Policy from time to time. Material changes will be reflected
    by updating the "Last updated" date above. Your continued use of the Service after changes
    take effect constitutes acceptance of the revised policy.</p>

    <h2>11. Contact Us</h2>
    <p>Questions about this Privacy Policy? Email us at
    <a href="mailto:${PRIVACY_EMAIL}">${PRIVACY_EMAIL}</a>.</p>`;
}

function termsBody() {
  return `
    <h1>Terms of Service</h1>
    <div class="legal-updated">Last updated: ${EFFECTIVE_DATE}</div>

    <p>These Terms of Service ("Terms") govern your access to and use of ${COMPANY} (the
    "Service"), an AI-powered content generation platform operated by ${COMPANY}, based in the
    United States. By creating an account or using the Service, you agree to these Terms. If
    you do not agree, do not use the Service.</p>

    <h2>1. The Service</h2>
    <p>${COMPANY} lets freelance writers and agencies generate marketing content, manage
    clients, run bulk generations, create invoices, and conduct outreach. Features may change,
    expand, or be discontinued over time.</p>

    <h2>2. Accounts and Eligibility</h2>
    <p>You must be at least 18 years old to use the Service. You are responsible for
    maintaining the confidentiality of your account credentials and for all activity under
    your account. Provide accurate information and keep it current.</p>

    <h2>3. Free Trial</h2>
    <p>New accounts include a free trial of five (5) content generations, with no payment card
    required. Once the trial allowance is used, a paid subscription is required to continue
    generating content.</p>

    <h2>4. Subscriptions, Billing, and Cancellation</h2>
    <ul>
      <li><strong>Plans.</strong> Paid plans are offered on a monthly basis, currently the
      Starter plan at $29/month and the Pro plan at $59/month. Plan features and limits are
      described in the app.</li>
      <li><strong>Payment.</strong> Payments are processed by Stripe. By subscribing, you
      authorize us, through Stripe, to charge your payment method on a recurring monthly
      basis.</li>
      <li><strong>Auto-renewal.</strong> Subscriptions renew automatically each month until
      cancelled.</li>
      <li><strong>Cancellation.</strong> You may cancel at any time through the billing portal.
      Cancellation takes effect at the end of the current billing period, and you retain access
      until then.</li>
      <li><strong>Refunds.</strong> Except where required by law, payments are non-refundable
      and we do not provide refunds or credits for partial billing periods.</li>
      <li><strong>Price changes.</strong> We may change subscription prices with reasonable
      advance notice; changes apply to subsequent billing periods.</li>
    </ul>

    <h2>5. Acceptable Use</h2>
    <p>You agree not to use the Service to: (a) generate or distribute unlawful, infringing,
    defamatory, or harmful content; (b) violate the rights of others; (c) attempt to reverse
    engineer, disrupt, or gain unauthorized access to the Service or its providers; (d) resell
    or misrepresent the Service; or (e) circumvent usage limits or security controls.</p>

    <h2>6. Your Content and Ownership</h2>
    <p>You retain ownership of the inputs you provide and, as between you and ${COMPANY}, the
    content generated for you through your account. You are solely responsible for your inputs
    and for how you use generated output, including ensuring you have the rights to any
    material you submit and that your use complies with applicable law.</p>

    <h2>7. AI-Generated Output Disclaimer</h2>
    <p>Content is produced by AI models (via Anthropic's API) and may be inaccurate,
    incomplete, or unsuitable for your purpose. Output is not professional advice. You are
    responsible for reviewing, editing, and verifying all generated content before relying on
    or publishing it. We do not warrant that output is original, non-infringing, or fit for
    any particular purpose.</p>

    <h2>8. Intellectual Property</h2>
    <p>The Service, including its software, design, and branding, is owned by ${COMPANY} and
    protected by intellectual property laws. These Terms do not grant you any right to our
    trademarks or to the underlying platform beyond the license to use the Service as
    intended.</p>

    <h2>9. Third-Party Services</h2>
    <p>The Service depends on third-party providers including Anthropic, Supabase, Stripe, and
    Vercel. We are not responsible for the availability or acts of these providers, and their
    services are subject to their own terms.</p>

    <h2>10. Termination</h2>
    <p>You may stop using the Service at any time. We may suspend or terminate your access if
    you violate these Terms or if necessary to protect the Service or other users. Upon
    termination, your right to use the Service ends, though provisions that by their nature
    should survive will remain in effect.</p>

    <h2>11. Disclaimer of Warranties</h2>
    <p>The Service is provided "as is" and "as available," without warranties of any kind,
    whether express or implied, including merchantability, fitness for a particular purpose,
    and non-infringement. We do not warrant that the Service will be uninterrupted, secure, or
    error-free.</p>

    <h2>12. Limitation of Liability</h2>
    <p>To the maximum extent permitted by law, ${COMPANY} will not be liable for any indirect,
    incidental, special, consequential, or punitive damages, or for lost profits or data. Our
    total liability for any claim arising out of or relating to the Service will not exceed the
    amount you paid us in the twelve (12) months preceding the claim.</p>

    <h2>13. Indemnification</h2>
    <p>You agree to indemnify and hold harmless ${COMPANY} from any claims, damages, or
    expenses arising from your use of the Service, your content, or your violation of these
    Terms.</p>

    <h2>14. Governing Law</h2>
    <p>These Terms are governed by the laws of the State of ${GOVERNING_STATE}, United States,
    without regard to its conflict-of-laws principles. Any disputes will be subject to the
    exclusive jurisdiction of the courts located in that state.</p>

    <h2>15. Changes to These Terms</h2>
    <p>We may modify these Terms from time to time. Material changes will be reflected by
    updating the "Last updated" date above. Your continued use of the Service after changes
    take effect constitutes acceptance of the revised Terms.</p>

    <h2>16. Contact Us</h2>
    <p>Questions about these Terms? Email us at
    <a href="mailto:${CONTACT_EMAIL}">${CONTACT_EMAIL}</a>.</p>`;
}

/**
 * Render a legal page.
 * @param {'privacy'|'terms'} kind
 * @param {(mode:'signup'|'signin')=>void} onCta
 */
export function showLegal(kind, onCta) {
  document.body.classList.add('landing-active');
  document.getElementById('root').classList.add('landing-active');

  const body = kind === 'terms' ? termsBody() : privacyBody();
  document.getElementById('root').innerHTML = `
  <div class="lp">
    ${navHtml()}
    <main class="lp-legal-wrap">
      <article class="legal">${body}</article>
    </main>
    ${footerHtml()}
  </div>`;

  document.querySelectorAll('#root [data-cta]').forEach(btn => {
    btn.addEventListener('click', () => onCta(btn.dataset.cta === 'signin' ? 'signin' : 'signup'));
  });

  window.scrollTo(0, 0);
}
